import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from '@environments/environment';
import * as sentry from '@sentry/angular';
import { AppComponent } from '@system/app.component';
import { appConfig } from '@system/app.config';

if (environment.sentry.dns) {
  sentry.init({
    dsn: environment.sentry.dns,
    environment: environment.name,
    release: environment.version,
    dist: environment.type,
    integrations: [sentry.browserTracingIntegration(), sentry.replayIntegration()],
    tracesSampleRate: environment.sentry.tracesSampleRate,
    replaysSessionSampleRate: environment.sentry.replaysSessionSampleRate,
    replaysOnErrorSampleRate: environment.sentry.replaysOnErrorSampleRate,
    dataCollection: {
      databaseQueryData: true,
      cookies: true,
      genAI: { inputs: true, outputs: true },
      httpBodies: ['incomingRequest', 'outgoingRequest', 'incomingResponse', 'outgoingResponse'],
      httpHeaders: { request: true, response: true },
      stackFrameVariables: true,
      urlQueryParams: true,
      userInfo: true,
      graphQL: { document: true, variables: true },
    },
    ignoreErrors: [
      /Invocation canceled due to the underlying connection being closed\.?/i,
      /WebSocket closed with status code: 1006 \(no reason given\)\.?/i,
      /Server returned an error on close: Connection closed with an error\.?/i,
      /Http failure response for .*: 4\d{2}\b/i,
      /Failed to read the 'responseText' property from 'XMLHttpRequest'.*\(was 'blob'\)/i,
    ],
  });
}

if (environment.type === 'production') {
  enableProdMode();

  // Disable console logs in production.
  window.console.log = () => {
    // Do nothing.
  };
}

bootstrapApplication(AppComponent, appConfig)
  .then(ref => {
    // Ensure Angular destroys itself on hot reloads.
    if (window['ngRef']) {
      window['ngRef'].destroy();
    }
    window['ngRef'] = ref;
  })
  .catch(error => {
    console.error(error);
  });
